import { render, staticRenderFns } from "./OverallKPI.vue?vue&type=template&id=3b68f292&scoped=true"
import script from "./OverallKPI.vue?vue&type=script&lang=js"
export * from "./OverallKPI.vue?vue&type=script&lang=js"
import style0 from "./OverallKPI.vue?vue&type=style&index=0&id=3b68f292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b68f292",
  null
  
)

export default component.exports